<div class="wrapper-body" *ngIf="apptDetails" #myComp>
    <div class="page-header align-items-lg-center d-flex flex-column flex-md-row">
        <h3 class="mb-4 mb-md-0">{{apptDetails.parentDetails.studentFirstName}}
            {{apptDetails.parentDetails.studentLastName}} Reschedule Appointment</h3>
    </div>
    <div class="row">
        <div class="col-md-6">
            <div class="card">
                <h5 class="mb-0 text-purple">Appointment Detail</h5>
                <hr>
                <div class="row">
                    <div class="col-md-6">
                        <label class="text-grey">Location</label>
                        <p> {{apptDetails.appointmentDetails.location}}</p>
                    </div>
                    <div class="col-md-6">
                        <label class="text-grey">Diagnostician</label>
                        <p> {{apptDetails.appointmentDetails.diagnosticianName}}</p>
                    </div>
                    <div class="col-md-6">
                        <label class="text-grey"> Date</label>
                        <p> {{apptDetails.appointmentDetails.schedules[0].appointmentDate}}</p>
                    </div>
                    <div class="col-md-6">
                        <label class="text-grey">Time</label>
                        <p> {{apptDetails.appointmentDetails.schedules[0].appointmentTime}}</p>
                    </div>
                    <div class="col-md-6">
                        <label class="text-grey">Assessment Type</label>
                        <p> {{apptDetails.appointmentDetails.assesmentType}}</p>
                    </div>

                    <div class="col-md-6">
                        <label class="text-grey">Assessment Mode</label>
                        <p> {{apptDetails.appointmentDetails.schedules[0].meetingType}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <form class="custom-form" [formGroup]="AppointmentForm" autocomplete="off">
                <div class="card light">
                    <h5 class="mb-0 text-purple">Reschedule Details</h5>
                    <hr>
                    <div class="row">
                        <div class="col-12" *ngIf="locations">
                            <select (change)="selectLocation()" formControlName="locationId" [(ngModel)]="locationId"
                                id="testingLocation">
                                <option value="" selected disabled>Choose Testing Location</option>
                                <option *ngFor="let city of locations.data" [ngValue]="city.id">{{city.name}}
                                </option>
                            </select>
                        </div>
                        <div class="col-12">
                            <input type="text" placeholder="Select Diagnostician" data-toggle="modal"
                                data-target="#schedulerModal" autocomplete="off" formControlName="diagnosticianId"
                                (click)="selectLocation()" [ngModel]="resourceName" readonly>
                        </div>
                        <div class="col-12">
                            <input type="text" placeholder="Date" formControlName="appointmentDate"
                                [ngModel]="assessmentDate" readonly>
                        </div>
                        <div class="col-12">
                            <input type="text" placeholder="Time" formControlName="appointmentTime" readonly
                                [ngModel]="appointmentTime">
                        </div>
                        <div class="col-12 my-2">
                            <button [ngClass]="{'grey' : AppointmentForm.invalid }" [disabled]="AppointmentForm.invalid"
                                type="submit" (click)="submitForm()" class="theme-button green">Save</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>


<!-- Scheduler Modal -->
<div class="modal fade create_appointment-modal" id="schedulerModal" data-keyboard="false" tabindex="-1"
    aria-labelledby="schedulerModal" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="actions">
                <button class="theme-button grey float-right" (click)="onDeleteClick()"
                    data-dismiss="modal">{{reset}}</button>
                <a class="theme-button green float-right mr-2" data-dismiss="modal">Save</a>
            </div>
            <div class="scheduler mt-2" *ngIf="show">
                <div class="card">
                    <mbsc-eventcalendar invalidateEvent="start-end" [clickToCreate]="clickToCreate"
                        [options]="calendarOptions" [invalid]="invalid" [view]="view" [data]="myEvents" groupBy="date"
                        [resources]="myResources" [resourceTemplate]="resourceTemp">
                        <ng-template #resourceTemp let-resource>
                            <div class="header-resource-template-content">
                                <!-- <img class="header-resource-avatar mb-2" [src]="resource.img" [width]="50" /> -->
                                <div class="header-resource-name">{{resource.name}}</div>
                            </div>
                        </ng-template>
                    </mbsc-eventcalendar>

                    <mbsc-popup [options]="popupOptions" [anchor]="popupAnchor" [buttons]="popupButtons"
                        [headerText]="popupHeaderText" #popup>
                        <div class="mbsc-form-group">
                            <mbsc-input label="Location" [(ngModel)]="locationName"></mbsc-input>

                            <mbsc-input label="Diagnostician" [(ngModel)]="resourceName"></mbsc-input>
                        </div>
                        <div class="mbsc-form-group">
                            <!-- <mbsc-input [disabled]="true" label="Select Time Slot" labelStyle="floating"></mbsc-input>
                            <mbsc-segmented-group [(ngModel)]="selectTimeSlots">
                                <mbsc-segmented value="slot1">Morning</mbsc-segmented>
                                <mbsc-segmented value="slot2">Afternoon</mbsc-segmented>
                            </mbsc-segmented-group> -->

                            <!-- Start Time -->
                            <!--
                            <mbsc-datepicker [(ngModel)]="popupEventDates" [options]="datePickerOptions"
                                [controls]="datetimePickerControls" [responsive]="datePickerResponsive"
                                [startInput]="endInput"></mbsc-datepicker>
                            <mbsc-input #endInput label="Start Time"></mbsc-input>
                             -->
                            <!-- Start Time -->

                            <div *ngIf="isEdit" class="mbsc-button-group">
                                <mbsc-button class="mbsc-button-block" color="danger" variant="outline"
                                    (click)="onDeleteClick()">Delete event
                                </mbsc-button>
                            </div>
                        </div>
                    </mbsc-popup>
                </div>
            </div>
        </div>
    </div>
</div>


<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-scale-multiple"></ngx-spinner>